import { lazy, Suspense } from "react";
import { profitDashboardMode } from "../profit-dashboard-config";

const BasicProfitDetail = lazy(() => import("./BasicProfitDetail"));
const LegacyProfitDetail = lazy(() => import("./LegacyProfitDetail"));

export default function ProfitDetailPage() {
  const Page = profitDashboardMode !== "legacy" ? BasicProfitDetail : LegacyProfitDetail;
  return <Suspense fallback={<p role="status">加载收益详情...</p>}><Page /></Suspense>;
}
